/*
 * Copyright (c) Nexign, JSC, 2019-2025.
 */

import includes from 'lodash/includes';

import { fastActionRoutes, fastBasketPages } from '../constants';

/**
 *
 *
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.0.1
 */

export interface ITooltipPosition {
    left: number;
    top: number;
}

export const getTooltipPosition = (blockStyle: DOMRect, tooltipStyle: DOMRect): ITooltipPosition => {
    let left = blockStyle.left + blockStyle.width / 2 - tooltipStyle.width / 2;
    const top = blockStyle.top - tooltipStyle.height - 4;

    if (left + tooltipStyle.width > window.innerWidth) {
        left = left - ((left + tooltipStyle.width) - window.innerWidth);
    }

    return { left, top };
};

export const setTooltipStyle = (tooltipBlock: HTMLDivElement, tooltip: HTMLDivElement): void => {
    const blockStyle = tooltipBlock.getBoundingClientRect();
    const styleTooltip = tooltip.getBoundingClientRect();
    const { left, top } = getTooltipPosition(blockStyle, styleTooltip);

    tooltip.style.transform = `translate(${left}px, ${top}px)`;
    tooltip.classList.add('visible');
};

export const getIsFastActionPage = (): boolean => {
    const locationPath = window.location.pathname;
    return includes(fastActionRoutes, locationPath);
};

export const getIsFastBasketPage = (): boolean => {
    const locationPath = window.location.pathname;
    return includes(fastBasketPages, locationPath);
};

export const getIsContextForBasket = (): boolean => {
    const isFastActionPage = getIsFastActionPage();
    const isFastBasketPage = getIsFastBasketPage();
    return isFastActionPage && !isFastBasketPage;
}
